'use strict';

/**
 Enhances a
 @param buttonDescr Object
 @return $
 */
Odigeo.UIElements.calendar = null;

Odigeo.UIElements.getCalendar = function(swipe) {
    if (Odigeo.UIElements.calendar) {
        return Odigeo.UIElements.calendar;
    }
    var $calendar;
    var $container;
    var $arrowL;
    var $arrowR;
    var bindToDom;
    var create;
    var renderMonth;
    var skipMonth;
    var setUpDay;
    var setDayNotAvailable;
    var calculateMinDate;
    var tapDayHandler;
    var hoverDayHandler;
    var hoverOutHandler;
    var closeHandler;
    var clearPastDates;
    var options = {};
    var defaults = {
        startDay: 1,
        weekends: [0, 6],
        numCals: 2,
        dates: [],
        index: 0,
        titleFormat: 'mmmm yyyy',
        dayNames: Odigeo.Utils.formatDate.i18n.dayShortNames,
        countryHolidays: Odigeo.Utils.calendarHolidays.countryHolidays ?
            Odigeo.Utils.calendarHolidays.countryHolidays : [],
        regionHolidays: Odigeo.Utils.calendarHolidays.regionHolidays ?
            Odigeo.Utils.calendarHolidays.regionHolidays : [],
        closeText: '',
        otherDaysSelectable: false,
        useMax: false,
    };

    const calendarStyleClasses = {
        cobalt: {
            arrowContainer: 'odf-flex-item',
            calendarBody: 'odf-flex-container-row odf-flex-container-nogutter',
            calendarContainer: 'prisma-calendar odf-flex-container-row odf-flex-container-nogutter' +
                ' odf-flex-container-align-stretch odf-space-outer-l',
            calendar: 'odf-calendar odf-flex-item',
            legend: 'odf-flex-container-column odf-flex-container-nogutter odf-flex-container-align-stretch',
            calendarSeparator: 'odf-calendar-separator odf-bg-secondary odf-space-outer-left-xl odf-space-outer-right-xl',
            title: 'odf-calendar-title',
            month: 'odf-calendar-month',
            header: 'odf-calendar-row',
            headerDay: 'odf-calendar-header-day',
            week: 'odf-calendar-row',
            day: 'odf-calendar-day',
            hiddenDay: 'odf-invisible',
            weekend: '',
            holidayRegions: 'odf-calendar-day-holiday-region',
            holidayAll: 'odf-calendar-day-holiday',

            selected: 'odf-calendar-day-selected',
            start: 'odf-calendar-day-start',
            range: 'odf-calendar-day-range',
            end: 'odf-calendar-day-end',
        },
        bluestone: {
            arrowContainer: 'od-ui-calendar-arrow',
            calendarBody: 'od-ui-calendar-body',
            calendarContainer: 'od-ui-calendar-container',
            calendar: 'od-ui-calendar',
            title: 'od-ui-calendar-title',
            month: 'od-ui-calendar-month',
            header: 'od-ui-calendar-header',
            headerDay: 'od-ui-calendar-header-day',
            week: 'od-ui-calendar-week',
            day: 'od-ui-calendar-day',
            hiddenDay: '',
            weekend: 'weekend',
            holidayRegions: 'country-holidays regions',
            holidayAll: 'country-holidays all',

            selected: '',
            start: 'active',
            range: 'active',
            end: 'active',
        },
    };

    const styleClasses = calendarStyleClasses[Odigeo.AB.isCssVariationHeaderDesktop? 'cobalt' : 'bluestone'];

    setUpDay = function($day, current, date, today) {
        $calendar.trigger('setAttributes.remove', {
            $day: $day,
            attr: 'data-uicalendar-segment data-uicalendar-type',
        });

        if (current.getUTCMonth() !== date.getUTCMonth()) {
            var checkCurrentMonth =
                current.getUTCMonth() - date.getUTCMonth() +
                (12 * (current.getUTCFullYear() - date.getUTCFullYear()));
            if (checkCurrentMonth === -1) {
                $day.addClass(`prev other ${styleClasses.hiddenDay}`);
            } else if (checkCurrentMonth === 1) {
                $day.addClass(`next other ${styleClasses.hiddenDay}`);
            }
        } else if (Odigeo.Utils.equalDates(current, today)) {
            $day.addClass('today');
        }
    };

    const isDateMoreThan1Year = function(today, date2) {
        // check if date2 is after 1 year from today
        let nextYear = new Date(today);
        nextYear.setUTCFullYear(today.getUTCFullYear() + 1);
        return nextYear <= date2;
    };

    const renderCalendar = function(calDate) {
        if (Odigeo.AB.isCssVariationHeaderDesktop) {
            const now = new Date();
            let today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));

            if (calDate) {
                $container.empty();

                let iterationCal = new Date(calDate);
                iterationCal.setUTCDate(1);
                $arrowL
                    .find('button')
                    .toggleClass('disabled', today >= iterationCal);

                let lastShownCalendarDate = new Date(iterationCal);
                lastShownCalendarDate.setUTCMonth(lastShownCalendarDate.getUTCMonth() + options.numCals);
                $arrowR
                    .find('button')
                    .toggleClass('disabled',
                        isDateMoreThan1Year(today, lastShownCalendarDate)
                    );

                for (let i = 0; i < options.numCals; i++) {
                    if ( Odigeo.AB.isCssVariationHeaderDesktop && i > 0) {
                        $container.append(
                            $('<div>', {class: styleClasses.calendarSeparator})
                        );
                    }

                    $container.append(renderMonth(iterationCal));
                    iterationCal.setUTCMonth(iterationCal.getUTCMonth() + 1);
                }
            }
        }
    };

    renderMonth = function(date) {
        var now = new Date();
        var $cal;
        var $header;
        var $month;
        var $headerDay;
        var $weekDiv;
        var $dayDiv;
        var $day;
        var renderDaysOfWeek;
        var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
        var startDay = parseInt(Odigeo.Utils.formatDate.i18n.startDay, 10);
        var DAYS_IN_WEEK = Odigeo.Utils.formatDate.i18n.dayShortNames.length;
        var WEEKS_IN_MONTH = 6;
        var current;
        var min = calculateMinDate(today);
        var max = options.useMax ? Odigeo._.find(Odigeo._.slice(options.dates, options.index + 1)) : Infinity;
        var isReturnTrip = (options.type === 'dual');
        var thisDate = options.dates[options.index];
        var d;
        var w;

        current = new Date(date);
        current.setUTCDate(1);

        // Begin building the structure
        $cal = $('<div>', {'class': `${styleClasses.calendar} calendar`, 'data-date': current.getTime()});
        $cal.append($('<div>', {
            'class': styleClasses.title,
            'text': Odigeo.Utils.formatDate(date, options.titleFormat, true),
        }));

        // Calculate first day of the grid
        current.setUTCDate(current.getUTCDate() -
            ((current.getUTCDay() + (DAYS_IN_WEEK - startDay)) % DAYS_IN_WEEK));

        $month = $('<div>', {'class': styleClasses.month}).appendTo($cal);

        // Create header
        $header = $('<div>', {'class': styleClasses.header}).appendTo($month);

        for (d = 0; d < DAYS_IN_WEEK; d++) {
            $headerDay = $('<div>', {'class': styleClasses.headerDay});
            if (Odigeo._.includes(options.weekends, (d + startDay) % DAYS_IN_WEEK)) {
                $headerDay.addClass(styleClasses.weekend);
            }
            $header.append($headerDay.clone().text(options.dayNames[(d + startDay) % DAYS_IN_WEEK]));
        }

        $weekDiv = $('<div>', {'class': styleClasses.week});
        $dayDiv = $('<div>', {'class': styleClasses.day});

        renderDaysOfWeek = function($week) {
            for (d = 0; d < DAYS_IN_WEEK; d++) {
                $day = $dayDiv.clone()
                    .text(current.getUTCDate())
                    .attr('data-day', current.getUTCDate())
                    .addClass('calendar_day')
                    .addClass('day_' + Odigeo.Utils.formatDate(current, Odigeo.Utils.formatDate.masks.isoDate))
                    .appendTo($week);

                if (Odigeo._.includes(options.weekends, current.getUTCDay())) {
                    $day.addClass(styleClasses.weekend);
                }
                if (!Odigeo._.isEmpty(options.countryHolidays) || !Odigeo._.isEmpty(options.regionHolidays)) {
                    var dayAndMonth =
                        Odigeo.Utils.pad(current.getDate(), 2) + '/' +
                        Odigeo.Utils.pad(current.getMonth() + 1, 2) + '/' +
                        (current.getYear() - 100);

                    if (options.countryHolidays.indexOf(dayAndMonth) >= 0) {
                        $day.append($('<div>', {'class': styleClasses.holidayAll}));
                    } else if (options.regionHolidays.indexOf(dayAndMonth) >= 0) {
                        $day.append($('<div>', {'class': styleClasses.holidayRegions}));
                    }
                }
                if (min && (current < min || current > max)) {
                    setDayNotAvailable($day, current, date);
                } else {
                    setUpDay($day, current, date, today);

                    if (Odigeo.Utils.equalDates(current, thisDate)) {
                        const dataRangeType = (isReturnTrip && options.index === 1) ? 'end' : 'start';
                        $day.addClass(styleClasses[dataRangeType])
                            .attr('data-range', dataRangeType)
                            .toggleClass(styleClasses.selected, options.type !== 'dual');
                    } else if (isReturnTrip) {
                        if (options.dates.length > 2) {
                            options.length = 2;
                        }
                        if (Odigeo.Utils.equalDates(current, options.dates[0])) {
                            $day.addClass(styleClasses.start).attr('data-range', 'start');
                        } else if (!Odigeo._.isNull(options.dates[1]) &&
                            Odigeo.Utils.equalDates(current, options.dates[1])) {
                            $day.addClass(styleClasses.end).attr('data-range', 'end');

                            var segmentParams = {
                                $day: $day,
                                date: current,
                            };
                            $calendar.trigger('setAttributes.addSegment',
                                Odigeo._.extend(segmentParams, {attr: 'data-uicalendar-segment'}))
                                .trigger('setAttributes.addType',
                                    Odigeo._.extend(segmentParams, {attr: 'data-uicalendar-type'}));
                        } else if (current > options.dates[0] && current < options.dates[1]) {
                            var isAdjacent = $day.prev('[data-range]').addClass('adjacent').length > 0;

                            $day.toggleClass(styleClasses.range);
                            $day.toggleClass('adjacent', isAdjacent);
                        }
                    }
                }
                current.setUTCDate(current.getUTCDate() + 1);
            }
        };
        for (w = 0; w < WEEKS_IN_MONTH; w++) {
            // Avoid adding extra week if out of month
            if (!Odigeo._.isUndefined(options.variableHeight) &&
                w === (WEEKS_IN_MONTH - 1) &&
                current.getUTCMonth() !== date.getUTCMonth()) {
                break;
            }

            var $week = $weekDiv.clone().appendTo($month);
            renderDaysOfWeek($week);
        }

        Odigeo.trigger('Odigeo.ui.calendar:renderMonth', {
            $cal: $cal,
            options: options,
        });

        return $cal;
    };

    const renderCobaltHeaderHolidayLegend = function() {
        const hasRegionHolidays = !Odigeo._.isEmpty(Odigeo.Utils.calendarHolidays.countryHolidays);
        const hasHolidays = !Odigeo._.isEmpty(Odigeo.Utils.calendarHolidays.regionHolidays);
        if ( Odigeo.AB.isCssVariationHeaderDesktop && (hasRegionHolidays || hasHolidays ) ) {
            const legendWrapper = $('<div>', {
                'class': 'odf-text-neutral-500 prisma-text-sm odf-space-outer-bottom-l',
            });

            const $hollidayBallot = $('<span/>', {class: 'odf-space-outer-right-xs', text: '●'});

            legendWrapper.append($('<span>', {
                'class': 'odf-space-outer-right-m',
                'text': Odigeo.UIElements.translations.holidayLegends.country,
            }).prepend($hollidayBallot.clone().addClass('prisma-calendar-holiday-bg')));

            legendWrapper.append($('<span>', {
                'class': 'odf-space-outer-right-m',
                'text': Odigeo.UIElements.translations.holidayLegends.region,
            }).prepend($hollidayBallot.clone().addClass('prisma-calendar-holiday-region-bg')));

            return legendWrapper;
        }
    };

    create = function() {
        // Build skeleton
        $calendar = $('<div>', {'class': styleClasses.calendarBody});

        $container = $('<div>', {'class': styleClasses.calendarContainer});

        if ( Odigeo.AB.isCssVariationHeaderDesktop ) {
            const arrowButtonFunction = function(direction = 'left') {
                const directionButtonName = {
                    left: 'previous',
                    right: 'next',
                };

                const button = $('<button>', {
                    'class': ' calendar_arrow prisma-btn prisma-btn-default prisma-btn-icon-only prisma-btn-circle',
                    'data-direction': directionButtonName[direction],
                });
                button.append($('<span>', {'class': `odf-icon odf-icon-arrow-${direction}`}));

                const $shaddowContainer = $('<div>', {class: 'prisma-elevation-1 odf-img-circle'}).append(button);

                const outerSpace = direction === 'left'? 'odf-space-outer-right-l' : 'odf-space-outer-left-l';
                return $('<div>', {
                    'class': `${styleClasses.arrowContainer} ${outerSpace} `,
                    'css': {['margin-' + direction]: '-21px'},
                    'data-direction': directionButtonName[direction],
                }).append($shaddowContainer);
            };

            $arrowL = arrowButtonFunction('left');
            $arrowR = arrowButtonFunction('right');

            const $ContainerWithlegendWrapper = $('<div>', styleClasses.legend);
            $ContainerWithlegendWrapper.append($container);
            $ContainerWithlegendWrapper.append(renderCobaltHeaderHolidayLegend());

            $calendar
                .append($arrowL)
                .append($ContainerWithlegendWrapper)
                .append($arrowR);
        } else {
            $calendar = $('<div>', {'class': 'od-ui-calendar-body'});

            $container = $('<div>', {'class': 'od-ui-calendar-container'});

            $arrowL = $('<div>', {'class': 'arrow', 'data-direction': 'previous'});
            $arrowR = $('<div>', {'class': 'arrow', 'data-direction': 'next'});

            $calendar
                .append($('<div>', {'class': 'od-ui-calendar-arrow calendar_arrow'})
                    .append($arrowL))
                .append($container)
                .append($('<div>', {'class': 'od-ui-calendar-arrow calendar_arrow'})
                    .append($arrowR));
        }

        bindToDom();
    };

    bindToDom = function() {
        $calendar
            .on(Odigeo.Events.tap, '.calendar_arrow', skipMonth)
            .on(Odigeo.Events.tap, `.${styleClasses.day}`, tapDayHandler)
            .on(Odigeo.Events.tap, '.calendar_close', closeHandler)
            .on(Odigeo.Events.mouseover, `.${styleClasses.day}`, hoverDayHandler)
            .on(Odigeo.Events.mouseout, '.calendar', hoverOutHandler);

        if (!!Odigeo.Settings.getProperty('allowSwipeOnCalendars') && swipe !== 'false') {
            $calendar.on(Odigeo.Events.swipeLeft + ' ' + Odigeo.Events.swipeRight, skipMonth);
        }
    };

    setDayNotAvailable = function($day, current, date) {
        $day.addClass('disabled');

        if (current.getUTCMonth() !== date.getUTCMonth()) {
            $day.addClass(`other ${styleClasses.hiddenDay}`);
        } else if (Odigeo._.includes(['accommodation', 'separatestay'], options.calendarType)) {
            var currentTimestamp = current.getTime();
            var checkInTimestamp = options.relatedDates[0].getTime();
            var checkOutTimestamp = Odigeo._.last(options.relatedDates).getTime();
            var isInFlightsRange = Odigeo._.inRange(currentTimestamp, checkInTimestamp, checkOutTimestamp + 1);
            if (isInFlightsRange) {
                $day.addClass('od-calendar-day-outlined');
            }
        }
    };

    hoverDayHandler = function(e) {
        if (!options.hover || options.type !== 'dual') {
            return;
        }
        var $day = $(e.target);
        var $days = $container.find(`.${styleClasses.day}`);
        var $start;
        var startIndex;
        var endIndex;

        $days.removeClass('hover');

        if (options.index > 0 && Odigeo._.isDate(options.dates[options.index - 1])) {
            $start = $days.filter('[data-range="start"]').last();

            endIndex = $days.index($day);
            startIndex = $days.index($start);

            $days.filter(function(idx) {
                return idx > startIndex && idx < endIndex;
            }).addClass('hover');
        }
    };

    hoverOutHandler = function(e) {
        if ($(e.target).hasClass('calendar') && !!options.hover) {
            $container.find(`.${styleClasses.day}`).removeClass('hover');
        }
    };

    clearPastDates = function(modified, date) {
        if (options.permissible) {
            Odigeo._.each(options.dates, function(value, index) {
                // Ignore previous dates
                if (index <= options.index) {
                    return;
                }
                if (options.dates[index] && (options.dates[index] < date)) {
                    options.dates[index] = null;
                    modified.push(index);
                }
            });
        }
    };
    tapDayHandler = function(evt) {
        var $this = $(this);
        var modified = [];
        var $cal;
        var date;
        var mdate;

        evt.stopPropagation();
        evt.preventDefault();

        if (($this.hasClass('other') && !options.otherDaysSelectable) || $this.hasClass('disabled')) {
            return;
        }

        $cal = $this.closest('.calendar');

        date = new Date(parseInt($cal.data('date'), 10));
        mdate = new Date($container.children('.calendar:first-child').data('date'));
        if ($this.hasClass('next')) {
            date = new Date(date.setUTCMonth(date.getUTCMonth() + 1));
            mdate = new Date(mdate.setUTCMonth(mdate.getUTCMonth() + 1));
        } else if ($this.hasClass('prev')) {
            date = new Date(date.setUTCMonth(date.getUTCMonth() - 1));
            mdate = new Date(mdate.setUTCMonth(mdate.getUTCMonth() - 1));
        }

        date.setUTCDate($this.data('day'));

        if (options.dates && options.dates[options.index] >= 0) {
            options.dates[options.index] = date;
        }

        clearPastDates(modified, date);

        // Render calendars after the change
        if ( Odigeo.AB.isCssVariationHeaderDesktop ) {
            renderCalendar(mdate);
        } else {
            $container.empty();

            for (let i = 0; i < options.numCals; i++) {
                $container.append(renderMonth(mdate));
                mdate.setUTCMonth(mdate.getUTCMonth() + 1);
            }
        }

        $calendar.trigger('change', {
            selectedDate: date,
            dates: options.dates,
            index: options.index,
            modified: modified.length > 0 ? modified : undefined,
        });
    };

    closeHandler = function() {
        $calendar.trigger('close');
    };

    skipMonth = function(evt) {
        var $cals = $container.children();
        var now = new Date();
        var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
        var monthDate;
        var animateContainer = function(callback) {
            // This is intended to be used to handle animations
            callback();
        };

        evt.stopPropagation();

        if ( Odigeo.AB.isCssVariationHeaderDesktop ) {
            monthDate = new Date($cals.first().data('date'));
            const monthDirection = evt.type === Odigeo.Events.swipeLeft || $(this).data('direction') === 'next' ? 1 : -1;

            var newFirstCal = new Date(monthDate.setUTCMonth(monthDate.getUTCMonth() + monthDirection));

            let lastRenderableCal = new Date(newFirstCal);
            lastRenderableCal.setUTCMonth(lastRenderableCal.getUTCMonth() + options.numCals - 1);
            // check boundaries
            if ( today > newFirstCal || isDateMoreThan1Year(today, lastRenderableCal) ) {
                return;
            }

            renderCalendar(newFirstCal);
        } else {
            var nextYear;
            var newMonth;

            if (evt.type === Odigeo.Events.swipeLeft || $(this).children('.arrow').data('direction') === 'next') {
                monthDate = new Date($cals.last().data('date'));
                nextYear = new Date(Date.UTC(now.getUTCFullYear() + 1, now.getUTCMonth(), 1));
                if (monthDate < nextYear) {
                    newMonth = new Date($cals.last().data('date'));
                    newMonth.setUTCMonth(newMonth.getUTCMonth() + 1);
                    animateContainer(function() {
                        $cals.first().remove();
                        $container.append(renderMonth(newMonth));
                        $arrowR.toggleClass('disabled', today.getUTCMonth() === newMonth.getUTCMonth());
                        $arrowL.removeClass('disabled');
                    });
                }
            } else {
                monthDate = new Date($cals.first().data('date'));
                if (monthDate > today) {
                    newMonth = new Date($cals.first().data('date'));
                    newMonth.setUTCMonth(newMonth.getUTCMonth() - 1);
                    animateContainer(function() {
                        $cals.last().remove();
                        $container.prepend(renderMonth(newMonth));
                        $arrowL.toggleClass('disabled', today.getUTCMonth() === newMonth.getUTCMonth());
                        $arrowR.removeClass('disabled');
                    });
                }
            }
        }
    };

    calculateMinDate = function(today) {
        return Odigeo._.findLast(Odigeo._.slice(options.dates, 0, options.index), function(date) {
            return !!date && date > today;
        }) || today;
    };

    // Bootstrap the calendar
    create();

    Odigeo.UIElements.calendar = {
        $cal: $calendar,
        show: function(params) {
            var calDate;
            var now;
            var today;
            var i;
            var previousDate;
            var nextYear;
            /** params
             numCals,
             dates = []
             dateIndex
             mode
             closeButton
             */

            options = $.extend(options, defaults, params);

            now = new Date();
            today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));

            // First date being set
            if (options.index === 0) {
                if (Odigeo._.isDate(options.dates[0])) {
                    calDate = new Date(options.dates[0]);
                } else {
                    calDate = new Date(today);
                }
                // All other cases
            } else {
                i = options.index;
                previousDate = null;
                do {
                    previousDate = options.dates[--i];
                } while (previousDate === null && i >= 0);
                // if previousDate doesn't initializate
                if (!previousDate) {
                    calDate = new Date(today);
                } else {
                    // if no date has been set yet, display the previous date
                    if (previousDate) {
                        if (!options.dates[options.index]) {
                            calDate = new Date(Date.UTC(previousDate.getUTCFullYear(),
                                previousDate.getUTCMonth(), previousDate.getUTCDate()));
                        } else {
                            calDate = new Date(options.dates[options.index]);
                            if (!(calDate.getUTCMonth() === previousDate.getUTCMonth() &&
                                    calDate.getUTCFullYear() === previousDate.getUTCFullYear())) {
                                calDate.setUTCMonth(calDate.getUTCMonth() - options.numCals + 1);
                            }
                        }
                    }
                }
            }
            if (calDate) {
                // Avoid painting months further than the max date
                nextYear = new Date(today);
                nextYear.setUTCFullYear(today.getUTCFullYear() + 1);
                if (calDate.getUTCMonth() === nextYear.getUTCMonth() && calDate.getUTCFullYear() === nextYear.getUTCFullYear()) {
                    calDate.setUTCMonth(nextYear.getUTCMonth() - options.numCals + 1);
                    // Check if day overflowed, thus staying in the same month, to round to the last day of the
                    // previous month
                    if (calDate.getUTCMonth() === nextYear.getUTCMonth()) {
                        calDate.setUTCDate(0);
                    }
                }

                // Generate calendars
                if ( Odigeo.AB.isCssVariationHeaderDesktop ) {
                    renderCalendar(calDate);
                } else {
                    $container.empty();

                    // Move date to first day, to avoid "date overflows"
                    calDate.setUTCDate(1);
                    $arrowL.toggleClass('disabled', today.getUTCMonth() === calDate.getUTCMonth());

                    for (i = 0; i < options.numCals; i++) {
                        $container.append(renderMonth(calDate));
                        calDate.setUTCMonth(calDate.getUTCMonth() + 1);
                    }
                }
            }
        },
        skipMonth: function() {
            var $cals = $container.children();
            var now = new Date();
            var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
            var newMonth = new Date($cals.last().data('date'));

            newMonth.setUTCMonth(newMonth.getUTCMonth() + 1);
            $cals.first().remove();
            $container.append(renderMonth(newMonth));
            $arrowR.toggleClass('disabled', today.getUTCMonth() === newMonth.getUTCMonth());
            $arrowL.removeClass('disabled');
        },
    };
    return Odigeo.UIElements.calendar;
};
